const formatString = function (format, ...args: any[]) {
  if (!format) {
    return format
  }
  return format.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] != 'undefined' ? args[number] : match
  })
}

const isString = x => {
  return Object.prototype.toString.call(x) === '[object String]'
}

const isNonEmptyString = (str: string | null | undefined): boolean => {
  return str != null && str.trim() !== '';
}

const setCapitalLetter = text => {
  if (!text) {
    return ''
  }
  if (!isString(text)) {
    return '' + text
  }
  const textToRender = text.charAt(0).toUpperCase() + text.slice(1)
  return textToRender
}

const setLowerCaseLetter = text => {
  if (!text) {
    return ''
  }
  if (!isString(text)) {
    return '' + text
  }
  const textToRender = text.charAt(0).toLowerCase() + text.slice(1)
  return textToRender
}

const stripHtml = text => {
  if (text) {
    let tempElement = document.createElement('div')
    tempElement.innerHTML = text
    return tempElement.textContent || tempElement.innerText || ''
  }
  return
}

const unsensitiveCaseSearchMatch = (textToCompare, searchedText) => {
  return textToCompare?.toLowerCase().indexOf(searchedText?.toLowerCase()) !== -1
}

export { formatString, setCapitalLetter, stripHtml, setLowerCaseLetter, unsensitiveCaseSearchMatch, isNonEmptyString }
